import { reactive } from 'vue'
import type { Epic, EpicStatus, Priority } from '@/types'

export interface EpicsState {
  epics: Epic[]
  selectedEpic: Epic | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    projectId: string
    applicationId: string
    status: EpicStatus | ''
    priority: Priority | ''
    assignedTo: string
  }
}

export const getInitialState = (): EpicsState => ({
  epics: [],
  selectedEpic: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    applicationId: '',
    status: '',
    priority: '',
    assignedTo: '',
  },
})

export const createState = (): EpicsState => {
  return reactive(getInitialState())
}

export const resetState = (state: EpicsState): void => {
  const initial = getInitialState()
  state.epics = initial.epics
  state.selectedEpic = initial.selectedEpic
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
